import React, { Component } from "react";

export default class CartButton extends Component {
  render() {
    if(this.props.state.batteryTenderService === true && this.props.state.rvRefrigeratorPlugin === true) {
      return (
        <a
          className="text-center no-underline mx-auto bg-blue hover:bg-blue-light text-white font-bold py-4 px-5 border-b-4 border-blue-dark hover:border-blue rounded"
          href={`//risco-storage.com/cart/?add-more-to-cart=645,646&add-to-cart=${this.props.productID}&variation_id=${this.props.variationID}&quantity=${this.props
            .state.widthOfSpace *
            this.props.state.lengthOfSpace}`}
        >
          <i className="fas fa-cart-plus" /> Add to Cart!
        </a>
      );
    } else if (this.props.state.batteryTenderService === true) {
      return (
        <a
          className="text-center no-underline mx-auto bg-blue hover:bg-blue-light text-white font-bold py-4 px-5 border-b-4 border-blue-dark hover:border-blue rounded"
          href={`//risco-storage.com/cart/?add-more-to-cart=645&add-to-cart=${this.props.productID}&variation_id=${this.props.variationID}&quantity=${this.props
            .state.widthOfSpace *
            this.props.state.lengthOfSpace}`}
        >
          <i className="fas fa-cart-plus" /> Add to Cart!
        </a>
      );
    } else if (this.props.state.rvRefrigeratorPlugin === true) {
      return (
        <a
          className="text-center no-underline mx-auto bg-blue hover:bg-blue-light text-white font-bold py-4 px-5 border-b-4 border-blue-dark hover:border-blue rounded"
          href={`//risco-storage.com/cart/?add-more-to-cart=646&add-to-cart=${this.props.productID}&variation_id=${this.props.variationID}&quantity=${this.props
            .state.widthOfSpace *
            this.props.state.lengthOfSpace}`}
        >
          <i className="fas fa-cart-plus" /> Add to Cart!
        </a>
      );
    } else {
      return (
        <a
          className="text-center no-underline mx-auto bg-blue hover:bg-blue-light text-white font-bold py-4 px-5 border-b-4 border-blue-dark hover:border-blue rounded"
          href={`//risco-storage.com/cart/?add-to-cart=${this.props.productID}&variation_id=${this.props.variationID}&quantity=${this.props
            .state.widthOfSpace *
            this.props.state.lengthOfSpace}`}
        >
          <i className="fas fa-cart-plus" /> Add to Cart!
        </a>
      );
    }
    
  }
}
